import { useState, useEffect, useRef } from 'react'
import { getNextTargetMoment } from './components'
import moment from 'moment'

export const useScript = (src) => {
    const [status, setStatus] = useState(src ? 'loading' : 'idle')
    useEffect(() => {
        if (!src) {
            setStatus('idle')
            return
        }
        let script = document.querySelector(`script[src="${src}"]`)
        if (!script) {
            script = document.createElement('script')
            script.src = src
            script.async = true
            script.setAttribute('data-status', 'loading')
            document.body.appendChild(script)
            const setAttributeFromEvent = (event) => {
                script.setAttribute('data-status', event.type === 'load' ? 'ready' : 'error')
            }
            script.addEventListener('load', setAttributeFromEvent)
            script.addEventListener('error', setAttributeFromEvent)
        } else {
            setStatus(script.getAttribute('data-status'))
        }
        const setStateFromEvent = (event) => {
            setStatus(event.type === 'load' ? 'ready' : 'error')
        }
        script.addEventListener('load', setStateFromEvent)
        script.addEventListener('error', setStateFromEvent)
        return () => {
            if (script) {
                script.removeEventListener('load', setStateFromEvent)
                script.removeEventListener('error', setStateFromEvent)
            }
        }
    }, [src])
    return status
}

export function useAuctionTarget(firstClose, intervalMinutes, lotCount, endingItems, options = {}) {
    const { tickMs = 1000, returnMoment = false } = options

    const [state, setState] = useState(() => {
        try {
            const { targetMoment, targetIndex } = getNextTargetMoment(
                firstClose,
                intervalMinutes,
                lotCount,
                endingItems,
                moment(),
            )
            return {
                iso: targetMoment.toISOString(),
                targetIndex,
                targetDate: returnMoment ? targetMoment.clone() : targetMoment.toDate(),
            }
        } catch (e) {
            const now = moment()
            return {
                iso: now.toISOString(),
                targetIndex: 0,
                targetDate: returnMoment ? now : now.toDate(),
            }
        }
    })

    const lastIsoRef = useRef(state.iso)
    const lastIndexRef = useRef(state.targetIndex)

    useEffect(() => {
        let mounted = true

        function tick() {
            if (!mounted) return
            try {
                const { targetMoment, targetIndex } = getNextTargetMoment(
                    firstClose,
                    intervalMinutes,
                    lotCount,
                    endingItems,
                    moment(),
                )
                const iso = targetMoment.toISOString()

                if (iso !== lastIsoRef.current || targetIndex !== lastIndexRef.current) {
                    lastIsoRef.current = iso
                    lastIndexRef.current = targetIndex
                    setState({
                        iso,
                        targetIndex,
                        targetDate: returnMoment ? targetMoment.clone() : targetMoment.toDate(),
                    })
                }
            } catch (err) {}
        }

        tick()
        const id = setInterval(tick, Math.max(100, tickMs))

        return () => {
            mounted = false
            clearInterval(id)
        }
    }, [firstClose, intervalMinutes, lotCount, tickMs, returnMoment, endingItems])

    return { targetDate: state.targetDate, targetIndex: state.targetIndex }
}
